import { render, staticRenderFns } from "./TexTarea.vue?vue&type=template&id=0f7a50da&"
import script from "./TexTarea.vue?vue&type=script&lang=js&"
export * from "./TexTarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../create-website/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports